import { checkHttpStatusAuthCheck } from '../../../actions/utilAction';
import {
  actionCreator,
  AUDIT_LOG,
  checkHttpStatus,
  createSearchUrlForCustomAPI,
  GET_MASTERDATABYNAME,
  jsonApiHeader,
  LogActionTypes,
  LOGIN_LOG,
} from '../constants/ApiConstants';

export const getAuditLogList = (searchObj) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(LogActionTypes.get_audit_log.REQUEST));
    let query_params = createSearchUrlForCustomAPI(searchObj);    
    fetch(`${AUDIT_LOG}${query_params}`, {
      method: 'GET',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {       
        dispatch(actionCreator(LogActionTypes.get_audit_log.SUCCESS, response));
      })
      .catch(function(error) {
        // errorHandler(error);
      });
  };
};
export const getLoginLogList = (searchObj) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(LogActionTypes.get_login_log.REQUEST));
    let query_params = createSearchUrlForCustomAPI(searchObj);
    // let query_params = createSearchUrl(getObj);
    fetch(`${LOGIN_LOG}${query_params}`, {
      method: 'GET',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then((res)=>checkHttpStatusAuthCheck(res,dispatch,getState))
      .then(function(response) {
        // console.log(response);
        dispatch(actionCreator(LogActionTypes.get_login_log.SUCCESS, response));
      })
      .catch(function(error) {
        // errorHandler(error);
      });
  };
};


export const getMasterData = (masterData) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(LogActionTypes.get_masterdata.REQUEST));
    fetch(`${GET_MASTERDATABYNAME}`, {
      method: 'post',
      body: JSON.stringify(masterData),
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then((res)=>checkHttpStatusAuthCheck(res,dispatch,getState))
      .then(function(response) {
        // console.log('Master Data response: ', response);
        dispatch(actionCreator(LogActionTypes.get_masterdata.SUCCESS, response));
      })
      .catch(function(error) {
        console.log('error getMasterData ..', error);
      });
  };
};


// WEBPACK FOOTER //
// ./src/modules/Logs/actions/LogActions.js